import { useRouterState } from '@tanstack/react-router';
import { memo, useEffect } from 'react';

export const BodyBackgroundHandler = memo(function BodyBackgroundHandler() {
  const bodyBackground = useRouterState({
    select: ({ matches }) => {
      // Get bodyBackground from the most specific route's context
      for (let i = matches.length - 1; i >= 0; i--) {
        const context = matches[i]?.context;
        if (context && 'bodyBackground' in context && context.bodyBackground) {
          return context.bodyBackground;
        }
      }
      return null;
    },
  });

  useEffect(() => {
    if (bodyBackground) {
      document.documentElement.style.setProperty(
        '--body-background',
        bodyBackground,
      );
    } else {
      // Reset to default if no context is provided
      document.documentElement.style.setProperty(
        '--body-background',
        'var(--g-background)',
      );
    }
  }, [bodyBackground]);

  return null;
});
